import React from 'react';
import { Switch } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
//import { getPermissionLabel } from '../dataFlow';

interface IPermissionControlProps {
    isPublic: boolean;
    onChange: (checked: boolean) => void;
}

const PermissionControl: React.FC<IPermissionControlProps> = ({ isPublic, onChange }) => {
    return (
        <div className="permission-control">
            <div className="permission-label">{lang('公开')}</div>
            <div className="permission-control-content">
                <div className="permission-description">
                    {lang('公开后，任何持有链接的人都可以查看此证书；关闭后，证书仅自己可见')}
                </div>
                <Switch checked={isPublic} onChange={onChange} />
            </div>
        </div>
    );
};

export { PermissionControl };
